import * as React from 'react'
import { ReactElement, useEffect } from 'react'
import TimeReportForm from '../../components/Form/Finance/Report/TimeReportForm'
import TierReportForm from '../../components/Form/Finance/Report/TierReportForm'
import InvoiceReportForm from '../../components/Form/Finance/Report/InvoiceReportForm'
import { Stack } from '@fluentui/react'
import FilesPerUserReportForm from '../../components/Form/Finance/Report/FilesPerUserReportForm'
import BilledTurnoverReportForm from '../../components/Form/Finance/Report/BilledTurnoverReportForm'
import OngoingFilesReportForm from '../../components/Form/Finance/Report/OngoingFilesReportForm'
import OutstandingInvoicesForm from '../../components/Form/Finance/Report/OutstandingInvoicesForm'
import UserProductivityForm from '../../components/Form/Finance/Report/UserProductivityReportForm'
import WipReportForm from '../../components/Form/Finance/Report/WipReportForm'
import PartyCardReportForm from '../../components/Form/Finance/Report/PartyCardReportForm'
import useModules from '../../hooks/module/useModules'
import { ModuleType } from '../../context/GlobalContext'
import useHost from '../../hooks/useHost'
import FileClaimListReportForm from '../../components/Form/Finance/Report/FileClaimListReportForm'
import { AppAction } from '../../config/appConfig'
import { MenuItemKey } from '../../components/MainMenu'
import { useDispatch } from 'react-redux'

export type ReportFormType = {
    orientation: 'horizontal' | 'vertical'
}

export default function Reports(): ReactElement {
    const dispatch = useDispatch()
    const modules = useModules()
    const host = useHost()
    const orientation = 'vertical'

    useEffect(() => {
        dispatch({ type: AppAction.SetBreadcrumbs, payload: [MenuItemKey.Reports] })
    }, [])

    return (
        <Stack horizontal horizontalAlign="start" wrap tokens={{ childrenGap: 16 }}>
            <TimeReportForm orientation={orientation} />
            <OutstandingInvoicesForm orientation={orientation} />
            <BilledTurnoverReportForm orientation={orientation} />
            <UserProductivityForm orientation={orientation} />
            {modules.has(ModuleType.WorkInProgress) && <WipReportForm orientation={orientation} />}
            <OngoingFilesReportForm orientation={orientation} />
            <InvoiceReportForm orientation={orientation} />
            <TierReportForm orientation={orientation} />
            <FilesPerUserReportForm orientation={orientation} />
            <PartyCardReportForm orientation={orientation} />

            {['bdo-cls', 'dev'].includes(host?.RowKey) && <FileClaimListReportForm orientation={orientation} />}
        </Stack>
    )
}
